module.exports = __webpack_public_path__ + "e7677c1b7ad3e689a4b36ec9fb0557c9.svg";